export const TOGGLE_SIDE_MENU = "TOGGLE_SIDE_MENU";
export const LIKE_DISLIKE_PAIR = "LIKE_DISLIKE_PAIR"
export const SET_BROWSER_HISTORY = "SET_BROWSER_HISTORY"